import { API_endpoints } from "../config";

export const updateEmploy = async (login_id:number,profile_id:number, data: {first_name: string; last_name: string; email: string; is_admin: boolean;  is_statistic: boolean;}) => {
    try {
        const response = await fetch(API_endpoints.updateEmploy, {
            method: "POST", 
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ login_id,profile_id, ...data }),  
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Aktualisieren von Mitarbeiter Daten.");
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("EFehler beim Aktualisieren von Mitarbeiter Daten:", error);
        throw error;
    }
};
